import { fromFetch } from "rxjs/fetch";
import { switchMap, timer, retry, mergeMap, tap } from "rxjs";

export const fetchRetryWrapper = (url, options) => {
  return fromFetch(url, options).pipe(
    switchMap((response) => {
      if (response.ok) {
        console.log(response, "response in fetchRetryWrapper");
        return response.json();
      } else {
        console.log(response, "response in fetchRetryWrapper");
        throw new Error("Request failed in fetchRetryWrapper", response);
      }
    }),
    tap({
      error: (err) => console.log(err, 'error in fetchRetryWrapper'),
    }),
    retry({
      count: 4,
      delay: (error, retryCount) => {
        console.log(error, 'error in fetchRetryWrapper -> make another try');
        const interval = 1000;
        const delay = Math.pow(2, retryCount - 1) * interval; // 1, 2, 4, 8
        return timer(delay);
      },
    })
  );
};